import { isDev } from "../pages/costant";
import { GET, POST, ZDMFetch } from "./http";

const basicUrl = "https://telwin.consoles.zerynth.com/grafana/api/";
export const dashboardDataUid = "d9_nqv2Sz";
export const dashboardSettingsUid = "ix1H3DhSz";
export const dashboardStatisticsUid = "ZH4c3D2Ik";

export function findUser(loginOrEmail: string) {
  return ZDMFetch(
    GET,
    `${basicUrl}users/lookup?loginOrEmail=${encodeURIComponent(loginOrEmail)}`
  );
}

export function findPermissions() {
  return ZDMFetch(GET, `${basicUrl}org/users`);
}

export function getBasicDashboard(uid: string) {
  if (isDev) {
    return new Promise((resolve) =>
      resolve({
        meta: {
          type: "db",
          canSave: true,
          canEdit: true,
          canAdmin: true,
          canStar: true,
          slug: "esempio",
          url: "/grafana/d/bOSzrxd4kohj32/esempio",
          expires: "0001-01-01T00:00:00Z",
          created: "2023-11-06T18:13:00Z",
          updated: "2023-11-14T10:54:13Z",
          updatedBy: "admin",
          createdBy: "admin",
          version: 27,
          hasAcl: false,
          isFolder: false,
          folderId: 0,
          folderUid: "",
          folderTitle: "General",
          folderUrl: "",
          provisioned: false,
          provisionedExternalId: "",
        },
        dashboard: {
          annotations: {
            list: [
              {
                builtIn: 1,
                datasource: "-- Grafana --",
                enable: true,
                hide: true,
                iconColor: "rgba(0, 211, 255, 1)",
                name: "Annotations & Alerts",
                target: {
                  limit: 100,
                  matchAny: false,
                  tags: [],
                  type: "dashboard",
                },
                type: "dashboard",
              },
            ],
          },
          editable: true,
          fiscalYearStartMonth: 0,
          gnetId: null,
          graphTooltip: 1,
          id: 1,
          iteration: 1699959223101,
          links: [],
          liveNow: false,
          panels: [
            {
              datasource: null,
              gridPos: {
                h: 3,
                w: 24,
                x: 0,
                y: 0,
              },
              id: 25,
              options: {
                content:
                  '<div style="display:flex; justify-content:space-between; text-align: right;align-items:flex-start">\n<a> </a>\n\n<a style="margin-top:10px;"\nhref=\'$home_url\'>\n<img src="http://resources.demos.zerynth.com/images/zerynth_icon.png">\n</a>\n\n<p style="margin:0px;margin-top:5px;  font-size:3vw; width:60%;font-family: \'Open Sans\', sans-serif;font-weight: 700;text-align:center; width:100%">\n  $asset_name\n  </p>\n\n<img style="height:85px; margin-top:0px" \nsrc="http://resources.demos.zerynth.com/images/powered_by_zerynth.png">\n\n</div>',
                mode: "markdown",
              },
              pluginVersion: "8.2.2",
              targets: [
                {
                  format: "time_series",
                  group: [],
                  metricColumn: "none",
                  rawQuery: false,
                  rawSql:
                    "SELECT\n  $__time(time_column),\n  value1\nFROM\n  metric_table\nWHERE\n  $__timeFilter(time_column)\n",
                  refId: "A",
                  select: [
                    [
                      {
                        params: ["value"],
                        type: "column",
                      },
                    ],
                  ],
                  timeColumn: "time",
                  where: [
                    {
                      name: "$__timeFilter",
                      params: [],
                      type: "macro",
                    },
                  ],
                },
              ],
              type: "text",
            },
            {
              datasource: null,
              description: "",
              fieldConfig: {
                defaults: {
                  color: {
                    mode: "thresholds",
                  },
                  mappings: [],
                  noValue: "-",
                  thresholds: {
                    mode: "absolute",
                    steps: [
                      {
                        color: "text",
                        value: null,
                      },
                    ],
                  },
                },
                overrides: [
                  {
                    matcher: {
                      id: "byName",
                      options: "Stato Macchina",
                    },
                    properties: [
                      {
                        id: "mappings",
                        value: [
                          {
                            options: {
                              "-1": {
                                color: "#808080",
                                index: 3,
                                text: "Offline",
                              },
                              "0": {
                                color: "yellow",
                                index: 0,
                                text: "Offline",
                              },
                              "1": {
                                color: "green",
                                index: 1,
                                text: "Online",
                              },
                              "2": {
                                color: "red",
                                index: 2,
                                text: "Alarm",
                              },
                            },
                            type: "value",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    matcher: {
                      id: "byName",
                      options: "Tempo medio ciclo",
                    },
                    properties: [
                      {
                        id: "unit",
                        value: "dthms",
                      },
                    ],
                  },
                  {
                    matcher: {
                      id: "byName",
                      options: "Ore di Marcia",
                    },
                    properties: [
                      {
                        id: "unit",
                        value: "dthms",
                      },
                    ],
                  },
                ],
              },
              gridPos: {
                h: 4,
                w: 12,
                x: 0,
                y: 3,
              },
              id: 6,
              options: {
                colorMode: "value",
                graphMode: "none",
                justifyMode: "auto",
                orientation: "vertical",
                reduceOptions: {
                  calcs: ["lastNotNull"],
                  fields: "/.*/",
                  values: false,
                },
                text: {},
                textMode: "value_and_name",
              },
              pluginVersion: "8.2.2",
              targets: [
                {
                  format: "table",
                  group: [],
                  hide: false,
                  metricColumn: "none",
                  rawQuery: true,
                  rawSql:
                    "with\nstatus as (\n    select \ncase when type = 'connection' then 1 else 0 end as status \nfrom events \nwhere device_id = '$asset_id' and type in ('connection','disconnection') --and $__timeFilter(ts)\n    order by ts desc limit 1\n),\n\nval as (\n    select sum((payload#>'{vars, Ore di marcia,0}')::float) as ore_marcia,\n    avg((payload#>'{vars, Tempo Ciclo, 0}')::float) as t_medio\n    from data\n    where $__timeFilter(ts_device)\n    and device_id = '$asset_id'\n    and tag = 'd1'  \n)\n\nselect \n  coalesce((select status from status), -1) as \"Stato Macchina\"\n  ,(select ore_marcia from val) as \"Ore di Marcia\"\n  -- ,(select t_medio from val) as  \"Tempo medio ciclo\"\n\n",
                  refId: "B",
                  select: [
                    [
                      {
                        params: ["value"],
                        type: "column",
                      },
                    ],
                  ],
                  timeColumn: "time",
                  where: [
                    {
                      name: "$__timeFilter",
                      params: [],
                      type: "macro",
                    },
                  ],
                },
                {
                  format: "table",
                  group: [],
                  hide: false,
                  metricColumn: "none",
                  rawQuery: true,
                  rawSql:
                    "WITH\n  vista_fine AS (\n    SELECT\n      ts_device AS t_fine\n    FROM data\n    WHERE\n      device_id = '$asset_id'\n      AND tag in ('d1','s')\n      AND ( (payload#>'{vars, Elettrovalvola, 0}')::float > 0)\n    ORDER BY ts_device DESC LIMIT 1\n  ),\n  vista_inizio AS (\n    SELECT\n      ts_device AS t_inizio\n    FROM data\n    WHERE\n      device_id = '$asset_id'\n      AND tag IN ('d1','s')\n      AND ( (payload#>'{vars, Elettrovalvola, 0}')::float <= 0)\n      AND ts_device < (SELECT t_fine FROM vista_fine LIMIT 1)\n    ORDER BY ts_device DESC LIMIT 1\n  )\n  \nSELECT \nmax(ts_device)-min(ts_device) as \"Tempo Ciclo\"\nFROM data\nWHERE \n  device_id = '$asset_id'\n  AND tag IN ('d1','s')\n  AND ts_device >= (SELECT t_inizio FROM vista_inizio LIMIT 1)\n  AND ts_device <= (SELECT t_fine FROM vista_fine LIMIT 1);\n",
                  refId: "A",
                  select: [
                    [
                      {
                        params: ["value"],
                        type: "column",
                      },
                    ],
                  ],
                  timeColumn: "time",
                  where: [
                    {
                      name: "$__timeFilter",
                      params: [],
                      type: "macro",
                    },
                  ],
                },
              ],
              type: "stat",
            },
            {
              datasource: null,
              description: "",
              fieldConfig: {
                defaults: {
                  color: {
                    mode: "thresholds",
                  },
                  mappings: [],
                  noValue: "-",
                  thresholds: {
                    mode: "absolute",
                    steps: [
                      {
                        color: "text",
                        value: null,
                      },
                    ],
                  },
                },
                overrides: [
                  {
                    matcher: {
                      id: "byName",
                      options: "Stato Macchina",
                    },
                    properties: [
                      {
                        id: "mappings",
                        value: [
                          {
                            options: {
                              "-1": {
                                color: "#808080",
                                index: 3,
                                text: "Offline",
                              },
                              "0": {
                                color: "yellow",
                                index: 0,
                                text: "Offline",
                              },
                              "1": {
                                color: "green",
                                index: 1,
                                text: "Online",
                              },
                              "2": {
                                color: "red",
                                index: 2,
                                text: "Alarm",
                              },
                            },
                            type: "value",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    matcher: {
                      id: "byName",
                      options: "Tempo medio ciclo",
                    },
                    properties: [
                      {
                        id: "unit",
                        value: "dthms",
                      },
                    ],
                  },
                  {
                    matcher: {
                      id: "byName",
                      options: "Ore di Marcia",
                    },
                    properties: [
                      {
                        id: "unit",
                        value: "dthms",
                      },
                    ],
                  },
                ],
              },
              gridPos: {
                h: 4,
                w: 12,
                x: 12,
                y: 3,
              },
              id: 55,
              options: {
                colorMode: "value",
                graphMode: "none",
                justifyMode: "auto",
                orientation: "vertical",
                reduceOptions: {
                  calcs: ["lastNotNull"],
                  fields: "/.*/",
                  values: false,
                },
                text: {},
                textMode: "value_and_name",
              },
              pluginVersion: "8.2.2",
              targets: [
                {
                  format: "table",
                  group: [],
                  hide: false,
                  metricColumn: "none",
                  rawQuery: true,
                  rawSql:
                    "\n\n\n  select \n payload#>'{vars, Livello olio, 0}' as \"Livello olio\",\n payload#>'{vars, Pressione di mandata,0}' as \"Pressione mandata\",\n  payload#>'{vars, Pressione aspirazione,0}' as \"Pressione aspirazione\",\n payload#>'{vars, Temperatura di aspirazione ,0 }' as \"Temperatura di aspirazione\"\n from data\n    where $__timeFilter(ts_device)\n    and device_id = '$asset_id'\n    and tag = 'd1'\n    order by ts_device desc limit 1",
                  refId: "B",
                  select: [
                    [
                      {
                        params: ["value"],
                        type: "column",
                      },
                    ],
                  ],
                  timeColumn: "time",
                  where: [
                    {
                      name: "$__timeFilter",
                      params: [],
                      type: "macro",
                    },
                  ],
                },
              ],
              title: "Ultimi valori letti",
              type: "stat",
            },
            {
              datasource: null,
              fieldConfig: {
                defaults: {
                  color: {
                    fixedColor: "red",
                    mode: "fixed",
                  },
                  custom: {
                    axisLabel: "",
                    axisPlacement: "auto",
                    barAlignment: 0,
                    drawStyle: "line",
                    fillOpacity: 0,
                    gradientMode: "none",
                    hideFrom: {
                      legend: false,
                      tooltip: false,
                      viz: false,
                    },
                    lineInterpolation: "linear",
                    lineWidth: 1,
                    pointSize: 5,
                    scaleDistribution: {
                      type: "linear",
                    },
                    showPoints: "auto",
                    spanNulls: false,
                    stacking: {
                      group: "A",
                      mode: "none",
                    },
                    thresholdsStyle: {
                      mode: "off",
                    },
                  },
                  decimals: 2,
                  mappings: [],
                  min: 0,
                  thresholds: {
                    mode: "absolute",
                    steps: [
                      {
                        color: "yellow",
                        value: null,
                      },
                    ],
                  },
                  unit: "pressurebar",
                },
                overrides: [],
              },
              gridPos: {
                h: 5,
                w: 12,
                x: 0,
                y: 7,
              },
              id: 52,
              options: {
                legend: {
                  calcs: [],
                  displayMode: "list",
                  placement: "bottom",
                },
                tooltip: {
                  mode: "single",
                },
              },
              pluginVersion: "8.2.2",
              targets: [
                {
                  format: "time_series",
                  group: [],
                  hide: false,
                  metricColumn: "none",
                  rawQuery: true,
                  rawSql:
                    "\n\n\n  select \n  ts_device as time,\n-- payload#>'{vars, Livello olio, 0}' as \"Livello olio\",\n (payload#>'{vars, Pressione di mandata,0}')::float as \"Pressione mandata\"\n  -- payload#>'{vars, Pressione aspirazione,0}' as \"Pressione aspirazione\",\n-- payload#>'{vars, Temperatura di aspirazione ,0 }' as \"Temperatura di aspirazione\"\n from data\n    where $__timeFilter(ts_device)\n    and device_id = '$asset_id'\n    and tag = 'd1'\n    order by ts_device asc ",
                  refId: "B",
                  select: [
                    [
                      {
                        params: ["value"],
                        type: "column",
                      },
                    ],
                  ],
                  timeColumn: "time",
                  where: [
                    {
                      name: "$__timeFilter",
                      params: [],
                      type: "macro",
                    },
                  ],
                },
              ],
              title: "Pressione mandata",
              type: "timeseries",
            },
            {
              datasource: null,
              fieldConfig: {
                defaults: {
                  color: {
                    fixedColor: "red",
                    mode: "fixed",
                  },
                  custom: {
                    axisLabel: "",
                    axisPlacement: "auto",
                    barAlignment: 0,
                    drawStyle: "line",
                    fillOpacity: 0,
                    gradientMode: "none",
                    hideFrom: {
                      legend: false,
                      tooltip: false,
                      viz: false,
                    },
                    lineInterpolation: "linear",
                    lineWidth: 1,
                    pointSize: 5,
                    scaleDistribution: {
                      type: "linear",
                    },
                    showPoints: "auto",
                    spanNulls: false,
                    stacking: {
                      group: "A",
                      mode: "none",
                    },
                    thresholdsStyle: {
                      mode: "off",
                    },
                  },
                  decimals: 2,
                  mappings: [],
                  min: 0,
                  thresholds: {
                    mode: "absolute",
                    steps: [
                      {
                        color: "yellow",
                        value: null,
                      },
                    ],
                  },
                  unit: "percent",
                },
                overrides: [],
              },
              gridPos: {
                h: 5,
                w: 12,
                x: 12,
                y: 7,
              },
              id: 59,
              options: {
                legend: {
                  calcs: [],
                  displayMode: "list",
                  placement: "bottom",
                },
                tooltip: {
                  mode: "single",
                },
              },
              pluginVersion: "8.2.2",
              targets: [
                {
                  format: "time_series",
                  group: [],
                  hide: false,
                  metricColumn: "none",
                  rawQuery: true,
                  rawSql:
                    "\n\n\n  select \n  ts_device as time,\n(payload#>'{vars, Livello olio, 0}')::float as \"Livello olio\"\n-- (payload#>'{vars, Pressione di mandata,0}')::float as \"Pressione mandata\"\n  -- payload#>'{vars, Pressione aspirazione,0}' as \"Pressione aspirazione\",\n-- payload#>'{vars, Temperatura di aspirazione ,0 }' as \"Temperatura di aspirazione\"\n from data\n    where $__timeFilter(ts_device)\n    and device_id = '$asset_id'\n    and tag = 'd1'\n    order by ts_device asc ",
                  refId: "B",
                  select: [
                    [
                      {
                        params: ["value"],
                        type: "column",
                      },
                    ],
                  ],
                  timeColumn: "time",
                  where: [
                    {
                      name: "$__timeFilter",
                      params: [],
                      type: "macro",
                    },
                  ],
                },
              ],
              title: "Livello Olio",
              type: "timeseries",
            },
            {
              datasource: null,
              fieldConfig: {
                defaults: {
                  color: {
                    fixedColor: "red",
                    mode: "fixed",
                  },
                  custom: {
                    axisLabel: "",
                    axisPlacement: "auto",
                    barAlignment: 0,
                    drawStyle: "line",
                    fillOpacity: 0,
                    gradientMode: "none",
                    hideFrom: {
                      legend: false,
                      tooltip: false,
                      viz: false,
                    },
                    lineInterpolation: "linear",
                    lineWidth: 1,
                    pointSize: 5,
                    scaleDistribution: {
                      type: "linear",
                    },
                    showPoints: "auto",
                    spanNulls: false,
                    stacking: {
                      group: "A",
                      mode: "none",
                    },
                    thresholdsStyle: {
                      mode: "off",
                    },
                  },
                  decimals: 2,
                  mappings: [],
                  min: 0,
                  thresholds: {
                    mode: "absolute",
                    steps: [
                      {
                        color: "yellow",
                        value: null,
                      },
                    ],
                  },
                  unit: "pressurebar",
                },
                overrides: [],
              },
              gridPos: {
                h: 5,
                w: 12,
                x: 0,
                y: 12,
              },
              id: 57,
              options: {
                legend: {
                  calcs: [],
                  displayMode: "list",
                  placement: "bottom",
                },
                tooltip: {
                  mode: "single",
                },
              },
              pluginVersion: "8.2.2",
              targets: [
                {
                  format: "time_series",
                  group: [],
                  hide: false,
                  metricColumn: "none",
                  rawQuery: true,
                  rawSql:
                    "\n\n\n  select \n  ts_device as time,\n-- payload#>'{vars, Livello olio, 0}' as \"Livello olio\",\n-- (payload#>'{vars, Pressione di mandata,0}')::float as \"Pressione mandata\"\n  (payload#>'{vars, Pressione aspirazione,0}')::float as \"Pressione aspirazione\"\n-- payload#>'{vars, Temperatura di aspirazione ,0 }' as \"Temperatura di aspirazione\"\n from data\n    where $__timeFilter(ts_device)\n    and device_id = '$asset_id'\n    and tag = 'd1'\n    order by ts_device asc ",
                  refId: "B",
                  select: [
                    [
                      {
                        params: ["value"],
                        type: "column",
                      },
                    ],
                  ],
                  timeColumn: "time",
                  where: [
                    {
                      name: "$__timeFilter",
                      params: [],
                      type: "macro",
                    },
                  ],
                },
              ],
              title: "Pressione aspirazione",
              type: "timeseries",
            },
            {
              datasource: null,
              fieldConfig: {
                defaults: {
                  color: {
                    fixedColor: "red",
                    mode: "fixed",
                  },
                  custom: {
                    axisLabel: "",
                    axisPlacement: "auto",
                    barAlignment: 0,
                    drawStyle: "line",
                    fillOpacity: 0,
                    gradientMode: "none",
                    hideFrom: {
                      legend: false,
                      tooltip: false,
                      viz: false,
                    },
                    lineInterpolation: "linear",
                    lineWidth: 1,
                    pointSize: 5,
                    scaleDistribution: {
                      type: "linear",
                    },
                    showPoints: "auto",
                    spanNulls: false,
                    stacking: {
                      group: "A",
                      mode: "none",
                    },
                    thresholdsStyle: {
                      mode: "off",
                    },
                  },
                  decimals: 2,
                  mappings: [],
                  min: 0,
                  thresholds: {
                    mode: "absolute",
                    steps: [
                      {
                        color: "yellow",
                        value: null,
                      },
                    ],
                  },
                  unit: "watt",
                },
                overrides: [],
              },
              gridPos: {
                h: 5,
                w: 12,
                x: 12,
                y: 12,
              },
              id: 56,
              options: {
                legend: {
                  calcs: [],
                  displayMode: "list",
                  placement: "bottom",
                },
                tooltip: {
                  mode: "single",
                },
              },
              pluginVersion: "8.2.2",
              targets: [
                {
                  format: "time_series",
                  group: [],
                  hide: false,
                  metricColumn: "none",
                  rawQuery: true,
                  rawSql:
                    "\n\n\n  select \n  ts_device as time,\n-- payload#>'{vars, Livello olio, 0}' as \"Livello olio\",\n (payload#>'{vars, Pressione di mandata,0}')::float as \"Pressione mandata\"\n  -- payload#>'{vars, Pressione aspirazione,0}' as \"Pressione aspirazione\",\n-- payload#>'{vars, Temperatura di aspirazione ,0 }' as \"Temperatura di aspirazione\"\n from data\n    where $__timeFilter(ts_device)\n    and device_id = '$asset_id'\n    and tag = 'd1'\n    order by ts_device asc ",
                  refId: "B",
                  select: [
                    [
                      {
                        params: ["value"],
                        type: "column",
                      },
                    ],
                  ],
                  timeColumn: "time",
                  where: [
                    {
                      name: "$__timeFilter",
                      params: [],
                      type: "macro",
                    },
                  ],
                },
              ],
              title: "Potenza Assorbita",
              type: "timeseries",
            },
            {
              collapsed: false,
              datasource: null,
              gridPos: {
                h: 1,
                w: 24,
                x: 0,
                y: 17,
              },
              id: 61,
              panels: [],
              title: "Sezione Elettrovalvole",
              type: "row",
            },
            {
              datasource: null,
              fieldConfig: {
                defaults: {
                  color: {
                    fixedColor: "yellow",
                    mode: "fixed",
                  },
                  custom: {
                    axisLabel: "",
                    axisPlacement: "auto",
                    barAlignment: 0,
                    drawStyle: "line",
                    fillOpacity: 23,
                    gradientMode: "none",
                    hideFrom: {
                      legend: false,
                      tooltip: false,
                      viz: false,
                    },
                    lineInterpolation: "stepBefore",
                    lineWidth: 3,
                    pointSize: 5,
                    scaleDistribution: {
                      type: "linear",
                    },
                    showPoints: "auto",
                    spanNulls: false,
                    stacking: {
                      group: "A",
                      mode: "none",
                    },
                    thresholdsStyle: {
                      mode: "off",
                    },
                  },
                  decimals: 0,
                  mappings: [
                    {
                      options: {
                        "0": {
                          color: "yellow",
                          index: 0,
                          text: "OFF",
                        },
                        "1": {
                          color: "green",
                          index: 1,
                          text: "ON",
                        },
                      },
                      type: "value",
                    },
                  ],
                  min: 0,
                  thresholds: {
                    mode: "absolute",
                    steps: [
                      {
                        color: "yellow",
                        value: null,
                      },
                      {
                        color: "#EAB839",
                        value: 0,
                      },
                    ],
                  },
                  unit: "none",
                },
                overrides: [],
              },
              gridPos: {
                h: 7,
                w: 24,
                x: 0,
                y: 18,
              },
              id: 58,
              options: {
                legend: {
                  calcs: [],
                  displayMode: "list",
                  placement: "bottom",
                },
                tooltip: {
                  mode: "single",
                },
              },
              pluginVersion: "8.2.2",
              targets: [
                {
                  format: "time_series",
                  group: [],
                  hide: false,
                  metricColumn: "none",
                  rawQuery: true,
                  rawSql:
                    "\n\n\n  select \n  ts_device as time,\n(payload#>'{vars, Elettrovalvola, 0}')::int as \" \"\n-- (payload#>'{vars, Pressione di mandata,0}')::float as \"Pressione mandata\"\n  -- payload#>'{vars, Pressione aspirazione,0}' as \"Pressione aspirazione\",\n-- payload#>'{vars, Temperatura di aspirazione ,0 }' as \"Temperatura di aspirazione\"\n from data\n    where $__timeFilter(ts_device)\n    and device_id = '$asset_id'\n    and tag in('s')\n    order by ts_device asc ",
                  refId: "B",
                  select: [
                    [
                      {
                        params: ["value"],
                        type: "column",
                      },
                    ],
                  ],
                  timeColumn: "time",
                  where: [
                    {
                      name: "$__timeFilter",
                      params: [],
                      type: "macro",
                    },
                  ],
                },
              ],
              title: "Elettrovalvola 1",
              type: "timeseries",
            },
          ],
          refresh: "",
          schemaVersion: 31,
          style: "dark",
          tags: [],
          templating: {
            list: [
              {
                description: null,
                error: null,
                hide: 2,
                label: null,
                name: "asset_id",
                query: "dev-8f5lnln3jvqr",
                skipUrlSync: false,
                type: "constant",
              },
              {
                description: null,
                error: null,
                hide: 2,
                label: null,
                name: "asset_name",
                query: "Esempio Mapro",
                skipUrlSync: false,
                type: "constant",
              },
            ],
          },
          time: {
            from: "now-5m",
            to: "now",
          },
          timepicker: {
            refresh_intervals: ["5s", "10s", "30s", "1m"],
          },
          timezone: "",
          title: "Esempio",
          uid: "bOSzrxd4kohj32",
          version: 27,
        },
      })
    );
  }
  return ZDMFetch(GET, `${basicUrl}dashboards/uid/${uid}`);
}

export function createFolder(title: string) {
  if (isDev) {
    return new Promise((resolve) =>
      resolve({
        id: 22,
        uid: "WvEQ0JvIz",
        title: "test",
        url: "/grafana/dashboards/f/WvEQ0JvIz/test",
        hasAcl: false,
        canSave: true,
        canEdit: true,
        canAdmin: true,
        createdBy: "Anonymous",
        created: "2023-12-12T10:18:09Z",
        updatedBy: "Anonymous",
        updated: "2023-12-12T10:18:09Z",
        version: 1,
      })
    );
  }
  return ZDMFetch(POST, `${basicUrl}folders`, JSON.stringify({ title: title }));
}

export function createDashboard(rawData: any, folderId?: string) {
  if (isDev) {
    return new Promise((resolve) =>
      setTimeout(() => resolve({ id: "test-id" }), 1000)
    );
  }

  try {
    delete rawData["id"];
  } catch (error) {
    // Do nothing if the key is not present
  }

  try {
    delete rawData["uid"];
  } catch (error) {
    // Do nothing if the key is not present
  }

  return ZDMFetch(
    POST,
    `${basicUrl}dashboards/db`,
    JSON.stringify({
      dashboard: rawData,
      folderId: folderId ? folderId : 0,
      overwrite: false,
    })
  );
}

export function login(username: string, password: string) {
  return ZDMFetch(
    POST,
    `https://telwin.consoles.zerynth.com/grafana/login`,
    JSON.stringify({ user: username, password: password })
  );
}

export function getUsers() {
  if (isDev) {
    return new Promise((resolve) =>
      resolve([
        {
          id: 7,
          name: "a.saugo@telwin.com",
          login: "a.saugo@telwin.com",
          email: "a.saugo@telwin.com",
          avatarUrl: "/grafana/avatar/f86dea6c787196de35cdd5ddce790f76",
          isAdmin: false,
          isDisabled: false,
          lastSeenAt: "2023-06-01T14:12:48Z",
          lastSeenAtAge: "3 days",
          authLabels: [],
        },
        {
          id: 1,
          name: "",
          login: "admin",
          email: "admin@localhost",
          avatarUrl: "/grafana/avatar/46d229b033af06a191ff2267bca9ae56",
          isAdmin: true,
          isDisabled: false,
          lastSeenAt: "2023-06-05T10:45:28Z",
          lastSeenAtAge: "\u003c 1 minute",
          authLabels: [],
        },
        {
          id: 8,
          name: "g.bertacche@telwin.com",
          login: "g.bertacche@telwin.com",
          email: "g.bertacche@telwin.com",
          avatarUrl: "/grafana/avatar/9b946064725ed60de26232ece60b162d",
          isAdmin: false,
          isDisabled: false,
          lastSeenAt: "2013-05-23T08:40:39Z",
          lastSeenAtAge: "10 years",
          authLabels: [],
        },
        {
          id: 3,
          name: "gianluca@lab101.it",
          login: "gianluca@lab101.it",
          email: "gianluca@lab101.it",
          avatarUrl: "/grafana/avatar/0b1b3137c291c98739376578c6945d64",
          isAdmin: false,
          isDisabled: false,
          lastSeenAt: "2023-06-05T06:48:51Z",
          lastSeenAtAge: "3 hours",
          authLabels: [],
        },
        {
          id: 6,
          name: "m.marchioretto@telwin.com",
          login: "m.marchioretto@telwin.com",
          email: "m.marchioretto@telwin.com",
          avatarUrl: "/grafana/avatar/43f1f169334c5da6f609e9664bd110b2",
          isAdmin: false,
          isDisabled: false,
          lastSeenAt: "2023-05-31T12:56:44Z",
          lastSeenAtAge: "4 days",
          authLabels: [],
        },
        {
          id: 9,
          name: "n.covolo@telwin.com",
          login: "n.covolo@telwin.com",
          email: "n.covolo@telwin.com",
          avatarUrl: "/grafana/avatar/8ac53bd1c3f171d2d159ae494c7b39af",
          isAdmin: false,
          isDisabled: false,
          lastSeenAt: "2023-05-29T15:58:44Z",
          lastSeenAtAge: "6 days",
          authLabels: [],
        },
        {
          id: 5,
          name: "testNicola",
          login: "nicola",
          email: "n.lorenzini@zerynth.com",
          avatarUrl: "/grafana/avatar/bd89c7d2b5dd1ffdc4b357df8f535254",
          isAdmin: false,
          isDisabled: false,
          lastSeenAt: "2023-06-05T10:45:12Z",
          lastSeenAtAge: "\u003c 1 minute",
          authLabels: [],
        },
        {
          id: 2,
          name: "telwinDemo",
          login: "telwinDemo",
          email: "telwinDemo",
          avatarUrl: "/grafana/avatar/e7e48261f4f9e13997008aaf9195e315",
          isAdmin: false,
          isDisabled: false,
          lastSeenAt: "2023-05-09T13:00:52Z",
          lastSeenAtAge: "26 days",
          authLabels: [],
        },
        {
          id: 4,
          name: "Simone",
          login: "test@lab101.it",
          email: "test@lab101.it",
          avatarUrl: "/grafana/avatar/57145a7683f5a1ebb7a0e748160f7962",
          isAdmin: false,
          isDisabled: false,
          lastSeenAt: "2023-05-15T15:26:56Z",
          lastSeenAtAge: "20 days",
          authLabels: [],
        },
      ])
    );
  }
  return ZDMFetch(GET, `${basicUrl}users`);
}

const gianlucaID = 3; //gianluca@lab101.it - editor
const marchiorettoID = 6; //m.marchioretto@telwin.com - editor
const saugoID = 7; //a.saugo@telwin.com - editor
const bertaccheID = 8; //g.bertacche@telwin.com - viewer
const covoloID = 9; //n.covolo@telwin.com - viewer

export function setPermission(dashId: string, userId: string) {
  if (isDev) {
    return new Promise((resolve) =>
      setTimeout(
        () => resolve({ message: "Dashboard permissions updated" }),
        1000
      )
    );
  }
  const tmp = [
    {
      userId: bertaccheID,
      permission: 1, // 1 = Viewer
    },
    {
      userId: covoloID,
      permission: 1, // 1 = Viewer
    },
    {
      userId: gianlucaID,
      permission: 2, // 2 = Editor
    },
    {
      userId: marchiorettoID,
      permission: 2, // 2 = Editor
    },
    {
      userId: saugoID,
      permission: 2, // 2 = Editor
    },
  ];
  if (
    tmp.filter((item) => String(item.userId) === String(userId)).length === 0
  ) {
    tmp.push({
      userId: Number(userId),
      permission: 1, // 1 = Viewer
    });
  }
  return ZDMFetch(
    POST,
    `${basicUrl}dashboards/id/${dashId}/permissions`,
    JSON.stringify({
      items: tmp,
    })
  );
}

export function searchDashboards(
  user: string,
  password: string,
  folderId?: string
) {
  if (isDev) {
    return new Promise((resolve) =>
      setTimeout(
        () =>
          resolve([
            {
              id: 80,
              uid: "example-1",
              title: "Desk Gianluca",
              uri: "db/desk-gianluca",
              url: "/grafana/d/ZrpO92wVz/desk-gianluca",
              slug: "",
              type: "dash-db",
              tags: [],
              isStarred: false,
              sortMeta: 0,
            },
            {
              id: 81,
              uid: "example-2",
              title: "New Faresin Dashboard v1.2",
              uri: "db/new-faresin-dashboard-v1-2",
              url: "/grafana/d/ahigNEQVk/new-faresin-dashboard-v1-2",
              slug: "",
              type: "dash-db",
              tags: [],
              isStarred: false,
              sortMeta: 0,
            },
            {
              id: 73,
              uid: "example-3",
              title: "New Lab101 v1.1",
              uri: "db/new-lab101-v1-1",
              url: "/grafana/d/gbZn-cQVz/new-lab101-v1-1",
              slug: "",
              type: "dash-db",
              tags: [],
              isStarred: false,
              sortMeta: 0,
            },
            {
              id: 65,
              uid: "example-4",
              title: "New Saugo Dashboards v1.2",
              uri: "db/new-saugo-dashboards-v1-2",
              url: "/grafana/d/QTlCYFQVz/new-saugo-dashboards-v1-2",
              slug: "",
              type: "dash-db",
              tags: [],
              isStarred: false,
              sortMeta: 0,
            },
          ]),
        1000
      )
    );
  }
  return ZDMFetch(
    GET,
    `${basicUrl}search/?folderIds=${
      folderId ? folderId : "0"
    }&query=&starred=false`,
    undefined,
    `Basic ${btoa(`${user}:${password}`)}`
  );
}

export function findDeviceId(dashboardId: string) {
  if (isDev) {
    return new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            meta: {
              type: "db",
              canSave: true,
              canEdit: true,
              canAdmin: true,
              canStar: true,
              slug: "new-saugo-dashboards-v1-2",
              url: "/grafana/d/QTlCYFQVz/new-saugo-dashboards-v1-2",
              expires: "0001-01-01T00:00:00Z",
              created: "2023-05-25T07:41:12Z",
              updated: "2023-05-30T10:41:05Z",
              updatedBy: "admin",
              createdBy: "admin",
              version: 59,
              hasAcl: true,
              isFolder: false,
              folderId: 0,
              folderUid: "",
              folderTitle: "General",
              folderUrl: "",
              provisioned: false,
              provisionedExternalId: "",
            },
            dashboard: {
              annotations: {
                list: [
                  {
                    builtIn: 1,
                    datasource: "-- Grafana --",
                    enable: true,
                    hide: true,
                    iconColor: "rgba(0, 211, 255, 1)",
                    name: "Annotations \u0026 Alerts",
                    target: {
                      limit: 100,
                      matchAny: false,
                      tags: [],
                      type: "dashboard",
                    },
                    type: "dashboard",
                  },
                ],
              },
              description: "Ufficio",
              editable: true,
              fiscalYearStartMonth: 0,
              gnetId: null,
              graphTooltip: 1,
              id: 65,
              iteration: 1685442803955,
              links: [],
              liveNow: false,
              panels: [
                {
                  datasource: null,
                  gridPos: {
                    h: 4,
                    w: 24,
                    x: 0,
                    y: 0,
                  },
                  id: 25,
                  options: {
                    content:
                      '\u003cdiv style="display:flex; justify-content:space-between; text-align: right;align-items:flex-start"\u003e\n\u003ca\u003e \u003c/a\u003e\n\n\u003ca style="margin-top:10px;"\nhref=\'$home_url\'\u003e\n\u003cimg style="height:65px; margin-top:0px" src="https://upload.wikimedia.org/wikipedia/commons/9/97/Telwin_logo.jpg"\u003e\n\u003c/a\u003e\n\n\u003cp style="margin:0px;margin-top:5px;  font-size:2.5vw; width:40%;font-family: \'Open Sans\', sans-serif;font-weight: 400;text-align:center; width:100%"\u003e\n  $asset_name\n  \u003c/p\u003e\n\n\u003cimg style="height:65px; margin-top:0px" \nsrc="https://upload.wikimedia.org/wikipedia/commons/9/97/Telwin_logo.jpg"\u003e\n\n\u003c/div\u003e',
                    mode: "markdown",
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "time_series",
                      group: [],
                      metricColumn: "none",
                      rawQuery: false,
                      rawSql:
                        "SELECT\n  $__time(time_column),\n  value1\nFROM\n  metric_table\nWHERE\n  $__timeFilter(time_column)\n",
                      refId: "A",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  transparent: true,
                  type: "text",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "semi-dark-blue",
                        mode: "fixed",
                      },
                      mappings: [],
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [
                      {
                        matcher: {
                          id: "byName",
                          options: "Processo",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "10": {
                                    index: 0,
                                    text: "MIG MANUALE",
                                  },
                                  "11": {
                                    index: 1,
                                    text: "MIG SHORTARC",
                                  },
                                  "12": {
                                    index: 2,
                                    text: "MIG PULSE",
                                  },
                                  "13": {
                                    index: 9,
                                    text: "MIG POP",
                                  },
                                  "14": {
                                    index: 3,
                                    text: "MIG ROOT",
                                  },
                                  "15": {
                                    index: 4,
                                    text: "MIG DEEP",
                                  },
                                  "20": {
                                    index: 5,
                                    text: "MIG MAN SPOOLGUN",
                                  },
                                  "21": {
                                    index: 6,
                                    text: "MIG SH AR SPOOLGUN",
                                  },
                                  "30": {
                                    index: 7,
                                    text: "MMA",
                                  },
                                  "31": {
                                    index: 8,
                                    text: "TIG DC LIFT",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Filo",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "1": {
                                    index: 0,
                                    text: "FF",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "SS",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "ALMG5",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "ALSI5",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "CUAL8",
                                  },
                                  "6": {
                                    index: 5,
                                    text: "CUSI3",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  " 6": {
                                    index: 5,
                                    text: "1,6mm",
                                  },
                                  "1": {
                                    index: 0,
                                    text: "0,6mm",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "0,8mm",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "0,9mm",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "1,0mm",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "1,2mm",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Gas",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "1": {
                                    index: 0,
                                    text: "ARCO2",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "ARCO2 9208",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "CO2",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "ARO2 9802",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "ARCO2 9802",
                                  },
                                  "6": {
                                    index: 5,
                                    text: "AR",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Modalità",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "1": {
                                    index: 0,
                                    text: "2T",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "4T",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "4T-BiLevel",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "Spot",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Materiale",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  " 2": {
                                    index: 1,
                                    text: "SS",
                                  },
                                  "1": {
                                    index: 0,
                                    text: "FF",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "ALMG5",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "ALSI5",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "CUAL8",
                                  },
                                  "6": {
                                    index: 5,
                                    text: "CUSI3",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  gridPos: {
                    h: 5,
                    w: 12,
                    x: 0,
                    y: 4,
                  },
                  id: 57,
                  options: {
                    colorMode: "value",
                    graphMode: "area",
                    justifyMode: "auto",
                    orientation: "auto",
                    reduceOptions: {
                      calcs: ["lastNotNull"],
                      fields: "/.*/",
                      values: false,
                    },
                    text: {
                      valueSize: 30,
                    },
                    textMode: "auto",
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "table",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n-- 5 StateTft.Modality\t1=2T; 2=4T; 3=4T-BiLevel; 4=Spot\n-- 6 StateTft.Status\tbit0=Power; bit1=PurgeGas; bit2=WireFeed; bit3=Aqua; bit4=CadM; bit5=SaveCalibration\n                    -- 2 StateTft.Material\t1=FF; 2=SS; 3=ALMG5; 4=ALSI5; 5=CUAL8; 6=CUSI3\n\n(payload#\u003e'{b50_60,1}')::text as \"Processo\",\n(payload#\u003e'{b50_60,2}')::text as \"Materiale\",\n(payload#\u003e'{b50_60,3}')::text as \"Filo\",\n(payload#\u003e'{b50_60,4}')::text as \"Gas\",\n(payload#\u003e'{b50_60,5}')::text as \"Modalità\"\n-- (payload#\u003e'{Stf_bin}')::text as \"Stato\"\n\n\n\n\n\n\n\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('t','p') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device desc limit 1\n-- \n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Parametri Impostati",
                  type: "stat",
                },
                {
                  datasource: null,
                  description: "",
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "orange",
                        mode: "fixed",
                      },
                      decimals: 2,
                      mappings: [
                        {
                          options: {
                            "0": {
                              color: "#46f011",
                              index: 0,
                              text: "NO ALARM",
                            },
                            "1": {
                              color: "red",
                              index: 1,
                              text: "Term. Sec.",
                            },
                            "1024": {
                              color: "red",
                              index: 11,
                              text: "Sec Term Prot-",
                            },
                            "128": {
                              color: "red",
                              index: 8,
                              text: "Term. Prim.",
                            },
                            "16": {
                              color: "red",
                              index: 5,
                              text: "Aux Volt. GEN.",
                            },
                            "2": {
                              color: "red",
                              index: 2,
                              text: "Over Voltage",
                            },
                            "256": {
                              color: "red",
                              index: 9,
                              text: "All. Filo",
                            },
                            "32": {
                              color: "red",
                              index: 6,
                              text: "All. Acqua",
                            },
                            "4": {
                              color: "red",
                              index: 3,
                              text: "All. Cor.",
                            },
                            "512": {
                              color: "red",
                              index: 10,
                              text: "All. Temp. NTC.",
                            },
                            "64": {
                              color: "red",
                              index: 7,
                              text: "Under Volt",
                            },
                            "8": {
                              color: "red",
                              index: 4,
                              text: "Out short Circ.",
                            },
                          },
                          type: "value",
                        },
                      ],
                      min: 0,
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [],
                  },
                  gridPos: {
                    h: 5,
                    w: 6,
                    x: 12,
                    y: 4,
                  },
                  id: 60,
                  options: {
                    colorMode: "background",
                    graphMode: "none",
                    justifyMode: "center",
                    orientation: "auto",
                    reduceOptions: {
                      calcs: ["lastNotNull"],
                      fields: "/.*/",
                      values: false,
                    },
                    text: {},
                    textMode: "value",
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "table",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        'SELECT\n   (payload#\u003e\'{A}\')::integer as "Inter"\n\n\n  -- (payload#\u003e\'{A_bin,15}\')::integer as "Term. Sec.",\n  -- (payload#\u003e\'{A_bin,13}\')::integer as "All. Cor.",\n  -- (payload#\u003e\'{A_bin,10}\')::integer as "All. Acqua",\n  -- (payload#\u003e\'{A_bin,8}\')::integer as "Term. Prim.",\n  -- (payload#\u003e\'{A_bin,7}\')::integer as "All. Filo",\n  -- (payload#\u003e\'{A_bin,6}\')::integer as "All. Temp. NTC.",\n  -- (payload#\u003e\'{A_bin,-7}\')::integer as "Under Volt",\n  -- (payload#\u003e\'{A_bin,-11}\')::integer  as "Sec Term Prot-"\n  --   (payload#\u003e\'{A_bin,-2}\')::integer as "Over Voltage",\n  -- (payload#\u003e\'{A_bin,-4}\')::integer as "Out short Circ",\n  -- (payload#\u003e\'{A_bin,-5}\')::integer as "Aux Volt. GEN."\n\n-- MAPPA \n-- 2^0 = "Term. Sec.",\n-- 2^1 = "Over Voltage"\n-- 2^2 = "All. Cor."\n-- 2^3 = "Out short Circ"\n-- 2^4 = "Aux Volt. GEN."\n-- 2^5 = "All. Acqua"\n-- 2^6 = "Under Volt"\n-- 2^7 = "Term. Prim."\n-- 2^8 = "All. Filo"\n-- 2^9 = "All. Temp. NTC."\n-- 2^10 = "Sec Term Prot-""\n\n\n\nFROM data\nWHERE\ntag in (\'r\',\'s\',\'a\') AND\n  $__timeFilter(ts_device)\n  and device_id = \'$asset_id\' \nORDER BY ts_device desc limit 1\n\n\n\n',
                      refId: "New",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                    {
                      format: "table",
                      group: [],
                      hide: true,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n\n   (payload#\u003e'{A_bin,15}')::integer as \"Term. Sec.\",\n   (payload#\u003e'{A_bin,13}')::integer as \"All. Cor.\",\n   (payload#\u003e'{A_bin,10}')::integer as \"All. Acqua\",\n   (payload#\u003e'{A_bin,8}')::integer as \"Term. Prim.\",\n   (payload#\u003e'{A_bin,7}')::integer as \"All. Filo\",\n   (payload#\u003e'{A_bin,6}')::integer as \"All. Temp. NTC.\",\n   (payload#\u003e'{A_bin,-7}')::integer as \"Under Volt\",\n   (payload#\u003e'{A_bin,-11}')::integer  as \"Sec Term Prot-\"\n  --   (payload#\u003e'{A_bin,-2}')::integer as \"Over Voltage\",\n  -- (payload#\u003e'{A_bin,-4}')::integer as \"Out short Circ\",\n  -- (payload#\u003e'{A_bin,-5}')::integer as \"Aux Volt. GEN.\"\n\n\n\n\n\n\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('r','s','a') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device desc limit 1\n\n\n\n",
                      refId: "OLD",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Allarmi",
                  type: "stat",
                },
                {
                  datasource: null,
                  description: "",
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "orange",
                        mode: "fixed",
                      },
                      decimals: 2,
                      mappings: [
                        {
                          options: {
                            "0": {
                              color: "#46f011",
                              index: 0,
                              text: "NO ALARM",
                            },
                            "1": {
                              color: "red",
                              index: 1,
                              text: "Aux Volt. TFT",
                            },
                            "2": {
                              color: "red",
                              index: 2,
                              text: "SerialOff",
                            },
                            "4": {
                              color: "red",
                              index: 3,
                              text: "SerialError",
                            },
                            "8": {
                              color: "red",
                              index: 4,
                              text: "SPIError",
                            },
                          },
                          type: "value",
                        },
                      ],
                      min: 0,
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [],
                  },
                  gridPos: {
                    h: 5,
                    w: 6,
                    x: 18,
                    y: 4,
                  },
                  id: 77,
                  options: {
                    colorMode: "background",
                    graphMode: "none",
                    justifyMode: "center",
                    orientation: "auto",
                    reduceOptions: {
                      calcs: ["lastNotNull"],
                      fields: "/.*/",
                      values: false,
                    },
                    text: {},
                    textMode: "value",
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "table",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n  -- 0  StateTft.Alarms\tbit0=Vcheck; bit1=SerialOff; bit2=SerialError; bit3=SPIError\n    (((payload#\u003e'{b140_170,1}')::integer))  as \"payload\"\n\n--   (((payload#\u003e'{b140_170,1}')::integer)) \u0026 1   as \"Aux Volt. TFT\"\n-- ,(((payload#\u003e'{b140_170,1}')::integer)\u003e\u003e1) \u0026 1 as \"SerialOff\"\n-- ,(((payload#\u003e'{b140_170,1}')::integer)\u003e\u003e2) \u0026 1 as \"SerialError\"\n-- ,(((payload#\u003e'{b140_170,1}')::integer)\u003e\u003e3) \u0026 1 as \"SPIError\"\n\n  -- (payload#\u003e'{A_bin,13}')::integer as \"All. Cor.\",\n  \n\n\n\n\n\n\n\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('r') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device desc limit 1\n\n\n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Allarmi TFT",
                  type: "stat",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "semi-dark-blue",
                        mode: "fixed",
                      },
                      mappings: [],
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [],
                  },
                  gridPos: {
                    h: 5,
                    w: 7,
                    x: 0,
                    y: 9,
                  },
                  id: 53,
                  options: {
                    colorMode: "value",
                    graphMode: "area",
                    justifyMode: "auto",
                    orientation: "auto",
                    reduceOptions: {
                      calcs: ["lastNotNull"],
                      fields: "/.*/",
                      values: false,
                    },
                    text: {},
                    textMode: "auto",
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "table",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n\n\n\n  'S00' || (payload#\u003e'{b0_30,1}')::text as \"FW_TFT\",\n  'E' || (payload#\u003e'{b0_30,2}')::text as \"Edizione FW_TFT\",\n\n\n   (payload#\u003e'{b0_30,30}')::text as \"SN\"\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('f') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device desc limit 1\n-- \n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Parametri saldatrice",
                  type: "stat",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "red",
                        mode: "fixed",
                      },
                      decimals: 0,
                      mappings: [
                        {
                          options: {
                            "0": {
                              color: "yellow",
                              index: 0,
                              text: "IDLE",
                            },
                            "1": {
                              color: "green",
                              index: 1,
                              text: "WORKING",
                            },
                            "3": {
                              color: "yellow",
                              index: 2,
                              text: "OFF",
                            },
                            "4": {
                              color: "green",
                              index: 3,
                              text: "ON",
                            },
                          },
                          type: "value",
                        },
                      ],
                      min: 0,
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [],
                  },
                  gridPos: {
                    h: 5,
                    w: 5,
                    x: 7,
                    y: 9,
                  },
                  id: 80,
                  options: {
                    colorMode: "background",
                    graphMode: "none",
                    justifyMode: "auto",
                    orientation: "auto",
                    reduceOptions: {
                      calcs: ["lastNotNull"],
                      fields: "",
                      values: false,
                    },
                    text: {},
                    textMode: "auto",
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "table",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n  ts_device AS \"time\",\n     (payload#\u003e'{S_bin,-2}')::int as \"Stato\",\n\n     (payload#\u003e'{S_bin,-1}')::int +3 as \"PT\",\n\n   (payload#\u003e'{S_bin,-2}')::int +3 as \"PWM\"\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('r') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device desc limit 1\n\n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Stato Macchina",
                  type: "stat",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "red",
                        mode: "palette-classic",
                      },
                      custom: {
                        axisLabel: "",
                        axisPlacement: "auto",
                        barAlignment: 0,
                        drawStyle: "line",
                        fillOpacity: 0,
                        gradientMode: "none",
                        hideFrom: {
                          legend: false,
                          tooltip: false,
                          viz: false,
                        },
                        lineInterpolation: "linear",
                        lineWidth: 1,
                        pointSize: 5,
                        scaleDistribution: {
                          type: "linear",
                        },
                        showPoints: "auto",
                        spanNulls: false,
                        stacking: {
                          group: "A",
                          mode: "none",
                        },
                        thresholdsStyle: {
                          mode: "off",
                        },
                      },
                      decimals: 0,
                      mappings: [],
                      min: 0,
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [],
                  },
                  gridPos: {
                    h: 5,
                    w: 12,
                    x: 12,
                    y: 9,
                  },
                  id: 81,
                  options: {
                    legend: {
                      calcs: [],
                      displayMode: "list",
                      placement: "bottom",
                    },
                    tooltip: {
                      mode: "single",
                    },
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "table",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n  ts_device AS \"time\",\n    -- (payload#\u003e'{S_bin,-2}')::int as \"Stato\",\n\n     (payload#\u003e'{S_bin,-1}')::int +3 as \"PT\",\n\n   (payload#\u003e'{S_bin,-2}')::int  as \"PWM\"\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('r') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device asc\n\n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Stato Macchina",
                  type: "timeseries",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "red",
                        mode: "palette-classic",
                      },
                      custom: {
                        axisLabel: "",
                        axisPlacement: "auto",
                        barAlignment: 0,
                        drawStyle: "line",
                        fillOpacity: 20,
                        gradientMode: "none",
                        hideFrom: {
                          legend: false,
                          tooltip: false,
                          viz: false,
                        },
                        lineInterpolation: "smooth",
                        lineStyle: {
                          fill: "solid",
                        },
                        lineWidth: 1,
                        pointSize: 1,
                        scaleDistribution: {
                          type: "linear",
                        },
                        showPoints: "auto",
                        spanNulls: false,
                        stacking: {
                          group: "A",
                          mode: "none",
                        },
                        thresholdsStyle: {
                          mode: "off",
                        },
                      },
                      decimals: 1,
                      mappings: [],
                      min: 0,
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [
                      {
                        matcher: {
                          id: "byName",
                          options: "Corrente in uscita",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "amp",
                          },
                          {
                            id: "color",
                            value: {
                              fixedColor: "semi-dark-red",
                              mode: "fixed",
                            },
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Tensione in uscita",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "volt",
                          },
                          {
                            id: "color",
                            value: {
                              fixedColor: "light-blue",
                              mode: "fixed",
                            },
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Velocità filo",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "m/min",
                          },
                          {
                            id: "color",
                            value: {
                              fixedColor: "green",
                              mode: "fixed",
                            },
                          },
                        ],
                      },
                    ],
                  },
                  gridPos: {
                    h: 13,
                    w: 21,
                    x: 0,
                    y: 14,
                  },
                  id: 52,
                  options: {
                    legend: {
                      calcs: [],
                      displayMode: "list",
                      placement: "bottom",
                    },
                    tooltip: {
                      mode: "single",
                    },
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "time_series",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n  ts_device AS \"time\",\n   (payload#\u003e'{b140_170,4}')::float as \"Corrente in uscita\",\n   (payload#\u003e'{b140_170,5}')::float/10 as \"Tensione in uscita\",\n   (payload#\u003e'{b140_170,6}')::float/10 as \"Velocità filo\"\n\n\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('r') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device ASC\n\n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Grafici",
                  type: "timeseries",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "semi-dark-red",
                        mode: "fixed",
                      },
                      decimals: 0,
                      mappings: [],
                      min: 0,
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "amp",
                    },
                    overrides: [],
                  },
                  gridPos: {
                    h: 4,
                    w: 3,
                    x: 21,
                    y: 14,
                  },
                  id: 58,
                  options: {
                    colorMode: "value",
                    graphMode: "area",
                    justifyMode: "auto",
                    orientation: "auto",
                    reduceOptions: {
                      calcs: ["lastNotNull"],
                      fields: "",
                      values: false,
                    },
                    text: {},
                    textMode: "auto",
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "time_series",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n  ts_device AS \"time\",\n   (payload#\u003e'{b140_170,4}')::integer as \"Corrente in uscita\"\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('r') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device desc limit 1\n\n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Corrente in uscita",
                  type: "stat",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "red",
                        mode: "fixed",
                      },
                      decimals: 1,
                      mappings: [],
                      min: 0,
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "volt",
                    },
                    overrides: [
                      {
                        matcher: {
                          id: "byName",
                          options: "Tensione in uscita",
                        },
                        properties: [
                          {
                            id: "color",
                            value: {
                              fixedColor: "#00fffb",
                              mode: "fixed",
                            },
                          },
                        ],
                      },
                    ],
                  },
                  gridPos: {
                    h: 4,
                    w: 3,
                    x: 21,
                    y: 18,
                  },
                  id: 54,
                  options: {
                    colorMode: "value",
                    graphMode: "none",
                    justifyMode: "auto",
                    orientation: "auto",
                    reduceOptions: {
                      calcs: ["lastNotNull"],
                      fields: "",
                      values: false,
                    },
                    text: {},
                    textMode: "auto",
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "time_series",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n  ts_device AS \"time\",\n   (payload#\u003e'{b140_170,5}')::float/10 as \"Tensione in uscita\"\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('r') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device desc limit 1\n\n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Tensione  in uscita",
                  type: "stat",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "red",
                        mode: "fixed",
                      },
                      decimals: 2,
                      mappings: [],
                      min: 0,
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "m/min",
                    },
                    overrides: [
                      {
                        matcher: {
                          id: "byName",
                          options: "Tensione in uscita",
                        },
                        properties: [
                          {
                            id: "color",
                            value: {
                              fixedColor: "blue",
                              mode: "fixed",
                            },
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Velocità filo",
                        },
                        properties: [
                          {
                            id: "color",
                            value: {
                              fixedColor: "#46f011",
                              mode: "fixed",
                            },
                          },
                        ],
                      },
                    ],
                  },
                  gridPos: {
                    h: 5,
                    w: 3,
                    x: 21,
                    y: 22,
                  },
                  id: 61,
                  options: {
                    colorMode: "value",
                    graphMode: "none",
                    justifyMode: "auto",
                    orientation: "auto",
                    reduceOptions: {
                      calcs: ["lastNotNull"],
                      fields: "",
                      values: false,
                    },
                    text: {},
                    textMode: "auto",
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "time_series",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\n  ts_device AS \"time\",\n   (payload#\u003e'{b140_170,6}')::float/10 as \"Velocità filo\"\n\n  -- ((payload-\u003e'Op')-\u003e\u003e0)::float as \"Pressione Olio\"\n\nFROM data\nWHERE\ntag in ('r') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \nORDER BY ts_device desc limit 1\n\n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Velocità filo",
                  type: "stat",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "red",
                        mode: "fixed",
                      },
                      custom: {
                        align: "center",
                        displayMode: "auto",
                      },
                      mappings: [
                        {
                          options: {
                            "0": {
                              color: "green",
                              index: 0,
                              text: "OFF",
                            },
                            "1": {
                              color: "red",
                              index: 1,
                              text: "ON",
                            },
                          },
                          type: "value",
                        },
                      ],
                      min: 0,
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [
                      {
                        matcher: {
                          id: "byName",
                          options: "Time",
                        },
                        properties: [
                          {
                            id: "custom.width",
                            value: 181,
                          },
                        ],
                      },
                    ],
                  },
                  gridPos: {
                    h: 9,
                    w: 24,
                    x: 0,
                    y: 27,
                  },
                  id: 76,
                  options: {
                    showHeader: true,
                    sortBy: [],
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "table",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "SELECT\nts_device as \"Time\",\n\n  (payload#\u003e'{A_bin,15}')::integer as \"Term. Sec.\",\n   (payload#\u003e'{A_bin,13}')::integer as \"All. Cor.\",\n   (payload#\u003e'{A_bin,10}')::integer as \"All. Acqua\",\n   (payload#\u003e'{A_bin,8}')::integer as \"Term. Prim.\",\n   (payload#\u003e'{A_bin,7}')::integer as \"All. Filo\",\n   (payload#\u003e'{A_bin,6}')::integer as \"All. Temp. NTC.\",\n   (payload#\u003e'{A_bin,-7}')::integer as \"Under Volt\",\n   (payload#\u003e'{A_bin,-11}')::integer  as \"Sec Term Prot-\",\n    (payload#\u003e'{A_bin,-2}')::integer as \"Over Voltage\",\n  (payload#\u003e'{A_bin,-4}')::integer as \"Out short Circ\",\n  (payload#\u003e'{A_bin,-5}')::integer as \"Aux Volt. GEN.\"\n\n\n\n\n\nFROM data\nWHERE\ntag in ('a') AND\n  $__timeFilter(ts_device)\n  and device_id = '$asset_id' \n  and ((payload#\u003e'{A}')::integer) \u003c\u003e0\nORDER BY ts_device desc limit 10\n\n\n\n",
                      refId: "A",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Storico Allarme",
                  transformations: [
                    {
                      id: "merge",
                      options: {},
                    },
                  ],
                  type: "table",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "semi-dark-blue",
                        mode: "fixed",
                      },
                      custom: {
                        align: "auto",
                        displayMode: "auto",
                      },
                      mappings: [],
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [
                      {
                        matcher: {
                          id: "byName",
                          options: "Processo",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "10": {
                                    index: 0,
                                    text: "MIG MANUALE",
                                  },
                                  "11": {
                                    index: 1,
                                    text: "MIG SHORTARC",
                                  },
                                  "12": {
                                    index: 2,
                                    text: "MIG PULSE",
                                  },
                                  "13": {
                                    index: 9,
                                    text: "MIG POP",
                                  },
                                  "14": {
                                    index: 3,
                                    text: "MIG ROOT",
                                  },
                                  "15": {
                                    index: 4,
                                    text: "MIG DEEP",
                                  },
                                  "20": {
                                    index: 5,
                                    text: "MIG MAN SPOOLGUN",
                                  },
                                  "21": {
                                    index: 6,
                                    text: "MIG SH AR SPOOLGUN",
                                  },
                                  "30": {
                                    index: 7,
                                    text: "MMA",
                                  },
                                  "31": {
                                    index: 8,
                                    text: "TIG DC LIFT",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Filo",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "1": {
                                    index: 0,
                                    text: "FF",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "SS",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "ALMG5",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "ALSI5",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "CUAL8",
                                  },
                                  "6": {
                                    index: 5,
                                    text: "CUSI3",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  " 6": {
                                    index: 5,
                                    text: "1,6mm",
                                  },
                                  "1": {
                                    index: 0,
                                    text: "0,6mm",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "0,8mm",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "0,9mm",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "1,0mm",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "1,2mm",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Gas",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "1": {
                                    index: 0,
                                    text: "ARCO2",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "ARCO2 9208",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "CO2",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "ARO2 9802",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "ARCO2 9802",
                                  },
                                  "6": {
                                    index: 5,
                                    text: "AR",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Modalità",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "1": {
                                    index: 0,
                                    text: "2T",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "4T",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "4T-BiLevel",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "Spot",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Materiale",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  " 2": {
                                    index: 1,
                                    text: "SS",
                                  },
                                  "1": {
                                    index: 0,
                                    text: "FF",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "ALMG5",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "ALSI5",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "CUAL8",
                                  },
                                  "6": {
                                    index: 5,
                                    text: "CUSI3",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                          {
                            id: "custom.width",
                            value: 117,
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Corrente",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "amp",
                          },
                          {
                            id: "custom.width",
                            value: 149,
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Tensione",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "volt",
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Filo consumato",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "lengthm",
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Durata",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "s",
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Id",
                        },
                        properties: [
                          {
                            id: "custom.width",
                            value: 55,
                          },
                        ],
                      },
                    ],
                  },
                  gridPos: {
                    h: 10,
                    w: 24,
                    x: 0,
                    y: 36,
                  },
                  id: 74,
                  options: {
                    showHeader: true,
                    sortBy: [],
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "table",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "with eventi_cons as (\nSELECT\ncoalesce((payload#\u003e'{S_bin,-2}')::integer,0) as stato,\nts_device as inizio\nfrom data\nwhere  device_id = '$asset_id'  and tag= 's' AND $__timeFilter(ts_device)\norder by ts_device desc )\n\n\n,info_11 as (\nselect stato, \ninizio, \nLEAD(stato,1) over (order by inizio) as stato_fine,\ncase when (LEAD(inizio,1) over (order by inizio)) is null then now() else (LEAD(inizio,1) over (order by inizio)) end as fine\nfrom eventi_cons\n)\n\n, info as (\n    select \n    stato, inizio, fine, fine-inizio as durata\n    from info_11\n     where stato = 1 and stato_fine = 0\n)\n\n,val as (\n    select \n    i.inizio,\n    i.fine,\n    avg((d.payload#\u003e'{b140_170,4}')::float) as corrente,\n    avg((d.payload#\u003e'{b140_170,5}')::float/10) as tensione,\n    (sum((payload#\u003e'{b140_170,6}')::float/10))*(('$temp_val'::float)/60) as filo\n-- (payload#\u003e'{b50_60,2}')::text as \"Materiale\",\n-- (payload#\u003e'{b50_60,3}')::text as \"Filo\",\n-- (payload#\u003e'{b50_60,4}')::text as \"Gas\",\n-- (payload#\u003e'{b50_60,5}')::text as \"Modalità\"\n    from data d, info i\n    where d.device_id = '$asset_id' \n    and d.tag = 'r' and d.ts_device between i.inizio and i.fine\n    group by i.inizio, i.fine\n)\n,proc as (\n    select \n    i.inizio,\n    i.fine,\n    max(((d.payload#\u003e'{b50_60,1}')::integer))   as  processo,\n    max(((d.payload#\u003e'{b50_60,2}')::integer))   as  materiale,\n    max(((d.payload#\u003e'{b50_60,3}')::integer))   as  filo,\n    max(((d.payload#\u003e'{b50_60,4}')::integer))   as  gas,\n    max(((d.payload#\u003e'{b50_60,5}')::integer))   as  modalita\n    from data d, info i\n    where d.device_id = '$asset_id' \n    -- and d.tag = 't' and d.ts_device between i.inizio and i.fine\n    and d.tag = 't' and $__timeFilter(d.ts_device)\n\n    group by i.inizio, i.fine)\n\n\n\n,final_result as(\n select \n     ROW_NUMBER() OVER (ORDER BY v.inizio) AS \"Id\",\n\nv.inizio as \"Inizio\" ,\nv.fine as \"Fine\",\nv.fine - v.inizio as \"Durata\",\nv.corrente as \"Corrente\",\nv.tensione as \"Tensione\",\nv.filo  as \"Filo consumato\",\np.processo AS \"Processo\",\np.materiale as \"Materiale\",\np.filo as \"Filo\",\np.gas as \"Gas\",\np.modalita as \"Modalità\"\nFROM\n   val v\n  LEFT JOIN\n    proc p ON v.inizio = p.inizio AND v.fine = p.fine\n)\n\nSELECT * FROM final_result;\n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Storico Saldature",
                  type: "table",
                },
                {
                  collapsed: false,
                  datasource: null,
                  gridPos: {
                    h: 1,
                    w: 24,
                    x: 0,
                    y: 46,
                  },
                  id: 69,
                  panels: [],
                  title: "Pannello costi",
                  type: "row",
                },
                {
                  datasource: null,
                  fieldConfig: {
                    defaults: {
                      color: {
                        fixedColor: "semi-dark-blue",
                        mode: "fixed",
                      },
                      custom: {
                        align: "auto",
                        displayMode: "auto",
                      },
                      mappings: [],
                      thresholds: {
                        mode: "absolute",
                        steps: [
                          {
                            color: "yellow",
                            value: null,
                          },
                        ],
                      },
                      unit: "none",
                    },
                    overrides: [
                      {
                        matcher: {
                          id: "byName",
                          options: "Processo",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "10": {
                                    index: 0,
                                    text: "MIG MANUALE",
                                  },
                                  "11": {
                                    index: 1,
                                    text: "MIG SHORTARC",
                                  },
                                  "12": {
                                    index: 2,
                                    text: "MIG PULSE",
                                  },
                                  "13": {
                                    index: 9,
                                    text: "MIG POP",
                                  },
                                  "14": {
                                    index: 3,
                                    text: "MIG ROOT",
                                  },
                                  "15": {
                                    index: 4,
                                    text: "MIG DEEP",
                                  },
                                  "20": {
                                    index: 5,
                                    text: "MIG MAN SPOOLGUN",
                                  },
                                  "21": {
                                    index: 6,
                                    text: "MIG SH AR SPOOLGUN",
                                  },
                                  "30": {
                                    index: 7,
                                    text: "MMA",
                                  },
                                  "31": {
                                    index: 8,
                                    text: "TIG DC LIFT",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Filo",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "1": {
                                    index: 0,
                                    text: "FF",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "SS",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "ALMG5",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "ALSI5",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "CUAL8",
                                  },
                                  "6": {
                                    index: 5,
                                    text: "CUSI3",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  " 6": {
                                    index: 5,
                                    text: "1,6mm",
                                  },
                                  "1": {
                                    index: 0,
                                    text: "0,6mm",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "0,8mm",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "0,9mm",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "1,0mm",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "1,2mm",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Gas",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "1": {
                                    index: 0,
                                    text: "ARCO2",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "ARCO2 9208",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "CO2",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "ARO2 9802",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "ARCO2 9802",
                                  },
                                  "6": {
                                    index: 5,
                                    text: "AR",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Modalità",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  "1": {
                                    index: 0,
                                    text: "2T",
                                  },
                                  "2": {
                                    index: 1,
                                    text: "4T",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "4T-BiLevel",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "Spot",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Materiale",
                        },
                        properties: [
                          {
                            id: "mappings",
                            value: [
                              {
                                options: {
                                  " 2": {
                                    index: 1,
                                    text: "SS",
                                  },
                                  "1": {
                                    index: 0,
                                    text: "FF",
                                  },
                                  "3": {
                                    index: 2,
                                    text: "ALMG5",
                                  },
                                  "4": {
                                    index: 3,
                                    text: "ALSI5",
                                  },
                                  "5": {
                                    index: 4,
                                    text: "CUAL8",
                                  },
                                  "6": {
                                    index: 5,
                                    text: "CUSI3",
                                  },
                                },
                                type: "value",
                              },
                            ],
                          },
                          {
                            id: "custom.width",
                            value: 117,
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Corrente",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "amp",
                          },
                          {
                            id: "custom.width",
                            value: 149,
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Durata",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "s",
                          },
                          {
                            id: "custom.width",
                            value: 216,
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Id",
                        },
                        properties: [
                          {
                            id: "custom.width",
                            value: 55,
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Costo Corrente",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "currencyEUR",
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Costo Filo",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "currencyEUR",
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Costo Totale",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "currencyEUR",
                          },
                        ],
                      },
                      {
                        matcher: {
                          id: "byName",
                          options: "Costo Tempo",
                        },
                        properties: [
                          {
                            id: "unit",
                            value: "currencyEUR",
                          },
                        ],
                      },
                    ],
                  },
                  gridPos: {
                    h: 10,
                    w: 24,
                    x: 0,
                    y: 47,
                  },
                  id: 78,
                  options: {
                    showHeader: true,
                    sortBy: [],
                  },
                  pluginVersion: "8.2.2",
                  targets: [
                    {
                      format: "table",
                      group: [],
                      hide: false,
                      metricColumn: "none",
                      rawQuery: true,
                      rawSql:
                        "with eventi_cons as (\nSELECT\ncoalesce((payload#\u003e'{S_bin,-2}')::integer,0) as stato,\nts_device as inizio\nfrom data\nwhere  device_id = '$asset_id'  and tag= 's' AND $__timeFilter(ts_device)\norder by ts_device desc )\n\n\n,info_11 as (\nselect stato, \ninizio, \nLEAD(stato,1) over (order by inizio) as stato_fine,\ncase when (LEAD(inizio,1) over (order by inizio)) is null then now() else (LEAD(inizio,1) over (order by inizio)) end as fine\nfrom eventi_cons\n)\n\n, info as (\n    select \n    stato, inizio, fine, fine-inizio as durata\n    from info_11\n     where stato = 1 and stato_fine = 0\n)\n\n,val as (\n    select \n    i.inizio,\n    i.fine,\n    avg((d.payload#\u003e'{b140_170,4}')::float) as corrente,\n    avg((d.payload#\u003e'{b140_170,5}')::float/10) as tensione,\n    (sum((payload#\u003e'{b140_170,6}')::float/10))*(('$temp_val'::float)/60) as filo\n-- (payload#\u003e'{b50_60,2}')::text as \"Materiale\",\n-- (payload#\u003e'{b50_60,3}')::text as \"Filo\",\n-- (payload#\u003e'{b50_60,4}')::text as \"Gas\",\n-- (payload#\u003e'{b50_60,5}')::text as \"Modalità\"\n    from data d, info i\n    where d.device_id = '$asset_id' \n    and d.tag = 'r' and d.ts_device between i.inizio and i.fine\n    group by i.inizio, i.fine\n)\n,proc as (\n    select \n    i.inizio,\n    i.fine,\n    max(((d.payload#\u003e'{b50_60,1}')::integer))   as  processo,\n    max(((d.payload#\u003e'{b50_60,2}')::integer))   as  materiale,\n    max(((d.payload#\u003e'{b50_60,3}')::integer))   as  filo,\n    max(((d.payload#\u003e'{b50_60,4}')::integer))   as  gas,\n    max(((d.payload#\u003e'{b50_60,5}')::integer))   as  modalita\n    from data d, info i\n    where d.device_id = '$asset_id' \n    -- and d.tag = 't' and d.ts_device between i.inizio and i.fine\n    and d.tag = 't' and $__timeFilter(d.ts_device)\n\n    group by i.inizio, i.fine)\n\n\n\n,final_result as(\n select \n     ROW_NUMBER() OVER (ORDER BY v.inizio) AS \"Id\",\n\nv.inizio as \"Inizio\" ,\nv.fine as \"Fine\",\nv.fine - v.inizio as \"Durata\",\nEXTRACT(EPOCH FROM ((v.fine-v.inizio)))*($costoTempo) as \"Costo Tempo\",\nv.corrente * $costoCorrente as \"Costo Corrente\",\n-- v.tensione as \"Tensione\",\nv.filo* $costoFilo  as \"Costo Filo\",\n(v.corrente * $costoCorrente)+(v.filo* $costoFilo)+(EXTRACT(EPOCH FROM ((v.fine-v.inizio)))*($costoTempo))  as \"Costo Totale\"\n-- p.processo AS \"Processo\",\n-- p.materiale as \"Materiale\",\n-- p.filo as \"Filo\",\n-- p.gas as \"Gas\",\n-- p.modalita as \"Modalità\"\nFROM\n   val v\n  LEFT JOIN\n    proc p ON v.inizio = p.inizio AND v.fine = p.fine\n)\n\nSELECT * FROM final_result;\n\n",
                      refId: "B",
                      select: [
                        [
                          {
                            params: ["value"],
                            type: "column",
                          },
                        ],
                      ],
                      timeColumn: "time",
                      where: [
                        {
                          name: "$__timeFilter",
                          params: [],
                          type: "macro",
                        },
                      ],
                    },
                  ],
                  title: "Costo Saldature",
                  type: "table",
                },
              ],
              refresh: false,
              schemaVersion: 31,
              style: "dark",
              tags: [],
              templating: {
                list: [
                  {
                    description: null,
                    error: null,
                    hide: 2,
                    label: null,
                    name: "asset_id",
                    query:
                      "dev-example" +
                      String(Math.floor(Math.random() * 100)) +
                      String(Math.floor(Math.random() * 100)) +
                      String(Math.floor(Math.random() * 100)) +
                      String(Math.floor(Math.random() * 100)),
                    skipUrlSync: false,
                    type: "constant",
                  },
                  {
                    description: null,
                    error: null,
                    hide: 2,
                    label: null,
                    name: "asset_name",
                    query:
                      "Saugo Dashboard" +
                      String(Math.floor(Math.random() * 100)),
                    skipUrlSync: false,
                    type: "constant",
                  },
                  {
                    description: null,
                    error: null,
                    hide: 2,
                    label: null,
                    name: "home_url",
                    query: "",
                    skipUrlSync: false,
                    type: "constant",
                  },
                  {
                    description: null,
                    error: null,
                    hide: 2,
                    label: null,
                    name: "temp_val",
                    query: "10",
                    skipUrlSync: false,
                    type: "constant",
                  },
                  {
                    description: null,
                    error: null,
                    hide: 2,
                    label: "Costo Corrente",
                    name: "costoCorrente",
                    query: "1",
                    skipUrlSync: false,
                    type: "constant",
                  },
                  {
                    description: null,
                    error: null,
                    hide: 2,
                    label: "Costo Filo",
                    name: "costoFilo",
                    query: "1",
                    skipUrlSync: false,
                    type: "constant",
                  },
                  {
                    description: null,
                    error: null,
                    hide: 2,
                    label: "Costo Filo",
                    name: "costoTempo",
                    query: "0.01",
                    skipUrlSync: false,
                    type: "constant",
                  },
                ],
              },
              time: {
                from: "now-7d",
                to: "now",
              },
              timepicker: {
                refresh_intervals: ["5s", "10s", "30s", "1m"],
              },
              timezone: "",
              title: "New Saugo Dashboards v1.2",
              uid: "example-test",
              version: 59,
            },
          }),
        500
      )
    );
  }
  return ZDMFetch(GET, `${basicUrl}dashboards/uid/${dashboardId}/`);
}
